import Typography from "../Typography";
import { MdClose } from "react-icons/md";

export default function Modal({ open, setOpen, children, className, titulo = null, botaoFechar=true }) {

    return (
        open &&
        <div className="fixed-tail inset-0 z-50 flex items-center bg-black bg-opacity-50 justify-center overflow-auto h-[100vh] left-40 top-4">
            <div className={`fixed-tail bg-neutras-white rounded-lg text-left shadow-xl transform transition-all p-4 ${className} divide-y divide-neutras-grey-dark`}>
                {titulo && botaoFechar &&
                    <Typography component="h3-bold" className="p-2 items-center flex justify-between">{titulo}
                        <MdClose className="h-6 w-6 text-text-primary cursor-pointer" onClick={() => setOpen(false)} />
                    </Typography>}
                <div className={`${titulo ? "pt-12 h-[92%]" : "h-full"}`}>
                    {children}
                </div>

            </div>
        </div>
    )
}